import React from "react";
import "../../assets/styles/departments-showcase.scss";

export type DepartmentItem = {
  /** Başlık */
  title: string;
  /** Paragraflar */
  paragraphs: string[];
  /** Görsel yol/URL */
  image: string;
  /** Buton (opsiyonel) */
  cta?: {
    label: string;
    href: string;
  };
  /** Bu öğe için vurgulu renk (opsiyonel) */
  accent?: string; // ör. "#2ba87a"
  /** Alternatif metin (opsiyonel) */
  alt?: string;
};

type DepartmentShowcaseProps = {
  items: DepartmentItem[];
  /** Sayfanın maksimum genişliği (opsiyonel) */
  maxWidth?: number; // px
};

const DepartmentShowcase: React.FC<DepartmentShowcaseProps> = ({
  items,
  maxWidth = 1200,
}) => {
  return (
    <section
      className="dept-showcase"
      style={{ ["--container-max" as any]: `${maxWidth}px` }}
    >
      {items.map((d, idx) => {
        const isReverse = idx % 2 === 1; // her ikinci satırda görsel sağa geçsin
        const styleVars = { ["--accent" as any]: d.accent ?? "#2ba87a" };

        return (
          <article
            key={idx}
            className={`dept-item ${isReverse ? "reverse" : ""}`}
            style={styleVars}
          >
            <figure className="dept-media">
              <img src={d.image} alt={d.alt ?? d.title} />
            </figure>

            <div className="dept-content">
              <h2 className="dept-title">{d.title}</h2>

              <div className="dept-desc">
                {d.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>

              {d.cta && (
                <div className="dept-cta">
                  <a className="btn-accent" href={d.cta.href}>
                    {d.cta.label}
                  </a>
                </div>
              )}
            </div>
          </article>
        );
      })}
    </section>
  );
};

export default DepartmentShowcase;
